if (!customElements.get('jmcp-cart-upsell')) {
  class JmcpCartUpsell extends HTMLElement {
    static busy = false;

    connectedCallback() {
      this.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.onSubmit);
    }

    onSubmit = async (event) => {
      const form = event.target.closest('[data-upsell-form]');
      if (!form) return;
      event.preventDefault();
      if (JmcpCartUpsell.busy) return;
      JmcpCartUpsell.busy = true;
      const error = this.querySelector('[data-upsell-error]');
      error.hidden = true;
      const inDrawer = this.closest('cart-drawer');
      const sections = [
        { node: document.querySelector('#main-cart-items'), selector: '.js-contents' },
        { node: document.querySelector('#main-cart-footer'), selector: '.js-contents' },
        { node: document.querySelector('#CartDrawer'), id: 'cart-drawer', selector: '.drawer__inner' },
        { node: document.querySelector('#cart-icon-bubble'), id: 'cart-icon-bubble', selector: '.shopify-section', whole: true },
        { node: document.querySelector('#cart-live-region-text'), id: 'cart-live-region-text', selector: '.shopify-section', whole: true },
      ].filter((section) => section.node).map((section) => ({ ...section, id: section.id || section.node.dataset.id }));
      const buttons = document.querySelectorAll('jmcp-cart-upsell button');
      buttons.forEach((button) => { button.disabled = true; });
      this.setAttribute('aria-busy', 'true');
      let added = false;
      try {
        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }],
            sections: sections.map((section) => section.id),
            sections_url: routes.cart_url,
          }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        added = true;
        const replacements = sections.map((section) => {
          const html = result.sections?.[section.id];
          if (!html) throw new Error('Cart section unavailable');
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
          const target = section.whole ? section.node : section.node.querySelector(section.selector);
          if (!source || !target) throw new Error('Cart section unavailable');
          return { target, source };
        });
        replacements.forEach(({ target, source }) => { target.innerHTML = source.innerHTML; });
        const checkout = document.querySelector(inDrawer ? '#CartDrawer-Checkout' : '#checkout');
        checkout?.focus();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jmcp-cart-upsell', cartData: result }).catch(() => {});
      } catch (failure) {
        if (added) {
          window.location.assign(routes.cart_url);
        } else {
          error.textContent = failure.message || this.dataset.error;
          error.hidden = false;
        }
      } finally {
        JmcpCartUpsell.busy = false;
        buttons.forEach((button) => { button.disabled = false; });
        this.removeAttribute('aria-busy');
      }
    };
  }
  customElements.define('jmcp-cart-upsell', JmcpCartUpsell);
}
